import { useEffect, useState,useCallback } from "react";
import { IoCashOutline } from "react-icons/io5";
import {sanitizeNumberInput} from "../../../utils/commonFunctions";


export const CheckOutGrid = ({
  balanceInfo = [],
  enabledCurrencies = [],
  onChange,
  roundFactor,
  disabledDeposits,
   drawerStatus,
     readOnly,
  errorsValidated = {},
  setShowDepositDetails
}) => {
  const [rows, setRows] = useState([]);

const roundByFactorConverted = useCallback((amount) => {
  if (amount === null || amount === undefined || amount === "") return "";

  const num = Number(amount);
  if (isNaN(num)) return "";

  const factor = Number(roundFactor);

  let roundedValue;

  if (!Number.isFinite(factor) || factor <= 0) {
    roundedValue = num;
  } else {
    roundedValue =
      Math.round((num + Number.EPSILON) / factor) * factor;
  }
  return roundedValue.toFixed(2);
}, [roundFactor]);


useEffect(() => {
  let mappedRows = [];

  if (balanceInfo.length) {
    mappedRows = balanceInfo.map((b) => ({
      currency: b.currencyCode,
      systemValue: roundByFactorConverted(b.amount),
       drawValue: roundByFactorConverted(b.drawValue),
      finalValue: roundByFactorConverted(b.finalValue),
      discrepancy: b.discrepancy,
      remarks: b.remark || ""
    }));
  } else if (enabledCurrencies.length) {
    mappedRows = enabledCurrencies.map((c) => ({
      currency: c.currencyCode,
      systemValue: roundByFactorConverted(0),
      drawValue: "",
      finalValue: "",
      discrepancy: false,
      remarks: ""
    }));
  }

  setRows(mappedRows);
}, [balanceInfo, enabledCurrencies, roundByFactorConverted]);


const updateRow = (index, field, value) => {
  const updated = [...rows];
  updated[index] = { ...updated[index], [field]: value };
  setRows(updated);
};

const evaluateRow = (index) => {
  setRows(prev => {
    const next = [...prev];
    const r = { ...next[index] };

    const system = Number(r.systemValue);
    const draw = Number(r.drawValue);

    if (r.drawValue === "" || r.drawValue === null) {
      r.finalValue = "";
      r.discrepancy = false;
      next[index] = r;
      return next;
    }

    if (!Number.isNaN(draw) && !Number.isNaN(system) && draw === system) {
      r.finalValue = r.drawValue;
      r.discrepancy = false;
      next[index] = r;
      return next;
    }

    if (!Number.isNaN(draw) && !Number.isNaN(system) && draw !== system) {
      r.discrepancy = true;
    }

    next[index] = r;
    return next;
  });
};



    useEffect(() => {
      onChange?.({ rows });
    }, [rows, onChange]);
    
      const splitErrorsByField = (errors = []) => {
  return {
    discrepancy: errors.filter(e =>
      e.toLowerCase().includes("mandatory")
    ),
    finalValue: errors.filter(e =>
      e.toLowerCase().includes("final")
    ),
    remarks: errors.filter(e =>
      e.toLowerCase().includes("remarks")
    )
  };
}

  return (
    <div className="checkout-grid-wrapper width100">
       {!readOnly ? <div className={`dialog__container_item input-container`}>
          <div className="flexRow justifyContentFlexStart">
       
                   <div className={`dialog__description`}>
                     <div className="sector-container card-list">
                     <span className="se-scanner-la3" ><>
                    Date & Time:
                     
                    <strong> {new Date()
         .toLocaleString('en-GB', {
           day: '2-digit',
           month: '2-digit',
           year: '2-digit',
           hour: 'numeric',
           minute: '2-digit',
           hour12: true
         })
         .toUpperCase()}</strong> 
                     </>
                     <>{", "}
          Status:{" "}
         <strong>
          {drawerStatus.status === "IN_USE" ? "IN USE" : drawerStatus.status}
          </strong>
          
 
         {drawerStatus.location && (
           <>
                   {","}{" "}
             Location:  <strong>{drawerStatus.location}</strong>
           </>
         )}
  
         {drawerStatus.user &&  <>
                 {","} {" "}
              User: <strong>{drawerStatus.user}</strong>
           </>}
       </>
                     </span>
                     </div>
                   </div>
            
                       {!disabledDeposits ? <button
                       disabled={disabledDeposits}
                       type="button"
                       title="View Deposit Details"
                       onClick={() => setShowDepositDetails(_=>!_)}
                     > 
                       <IoCashOutline size={20} />
                     </button>:null}
               </div>

          </div>:<></>}
 <div className='table-header'></div>
      <table className="currency-table">
        <thead>
          <tr>
            <th>Currency</th>
            <th>System Value</th>
            <th>Draw Value</th>
            <th>Discrepancy</th>
            <th>Final Value</th>
            <th>Remarks</th>
          </tr>
        </thead>

        <tbody>
          {rows.length === 0 ? (
    <tr>
      <td colSpan={6} style={{textAlign:"center",padding:'25px'}}>
        No Data
      </td>
    </tr>
  ) :
  (rows.map((r, i) => {
                const rowErrors = errorsValidated[i] || [];
                const { discrepancy, remarks , finalValue } = splitErrorsByField(rowErrors);

            return (
              <tr
                key={r.currency}
                className={`${i % 2 === 0 ? "tableEvenRowClass" : "tableRowClass"} ${rowErrors.length ? "row-error" : ""}`} >
                <td>{r.currency}</td>

                <td>{r.systemValue}</td>
                

                <td style={{verticalAlign:'top'}}>
                  <input
                      type="text"
                  inputMode="decimal"
                    className={`edit-input`}
                    placeholder="0.00"
                    disabled={readOnly}
                                value={r.drawValue}
                                onChange={(e) =>
                                  {if (readOnly) return;
                                updateRow(i, "drawValue", sanitizeNumberInput(e.target.value))}
                                }
                  onBlur={() => evaluateRow(i)}
                  onKeyDown={(e) => {
                  if (e.key === "Enter") {
                  evaluateRow(i);
                  e.target.blur();
                  }
            }}
                  />
                </td>

                <td>
                <div className={`dialog__container_item input-container`}>
                <div className={`alignItemsCenter justifyContentCenter dialog__description__checkbox`}>
                <input
                type="checkbox"
                checked={r.discrepancy}
                 disabled={r.drawValue === "" || readOnly}
                className={`${discrepancy.length ? "input-error" : ""}`}
                onChange={(e) =>{
                  if (readOnly) return;
                  updateRow(i, "discrepancy", e.target.checked)
                }
                }
                />

                </div>
                </div>
                      {discrepancy.map((msg, idx) => (
                <div key={idx} className="error-text text-danger">
                {msg}
                </div>
                ))}
                </td>
                <td style={{verticalAlign:'top' }}>
                 <input
                    type="text"
                  inputMode="decimal"
                 className={`edit-input ${
        finalValue.length ? "input-error" : ""
      }`}
                  
                 placeholder="0.00"
                  value={r.finalValue}
                  disabled={readOnly || !r.discrepancy} 
                                    onChange={(e) =>{
                                    updateRow(i, "finalValue", sanitizeNumberInput(e.target.value))
                                    }
                                    }
                />
 { finalValue.length ? <div className="remarks-error">
      {finalValue.map((msg, idx) => (
        <div key={idx} className="error-text text-danger">
          {msg}
        </div>
      ))}
    </div>:null}
                </td>


              <td style={{verticalAlign:'top' }}>
  <div className="remarks-cell">
    <input
      type="text"
      disabled={readOnly}
      className={`edit-input ${
        remarks.length ? "input-error" : ""
      }`}
      value={r.remarks}
      onChange={(e) => {
        updateRow(i, "remarks", e.target.value);
      }}
      placeholder="Remarks"
    />

   { remarks.length ? <div className="remarks-error">
      {remarks.map((msg, idx) => (
        <div key={idx} className="error-text text-danger">
          {msg}
        </div>
      ))}
    </div>:null}
  </div>
</td>
              </tr>
            );
          }))}
        </tbody>
      </table>
    </div>
  );
};
